import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { UpgradeProvider } from "@/context/UpgradeContext";
import AuthCallback from "@/pages/AuthCallback";
import Login from "@/pages/Login";
import ChatApp from "@/pages/ChatApp";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function Loader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F9F9F7]">
      <div className="flex gap-1.5">
        <span className="omni-dot" />
        <span className="omni-dot" style={{ animationDelay: "0.2s" }} />
        <span className="omni-dot" style={{ animationDelay: "0.4s" }} />
      </div>
    </div>
  );
}

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function LoginRoute() {
  const { user, loading } = useAuth();
  if (loading) return <Loader />;
  if (user) return <Navigate to="/" replace />;
  return <Login />;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<LoginRoute />} />
      <Route path="/payment/success" element={<Protected><PaymentSuccess /></Protected>} />
      <Route path="/payment/cancel" element={<Protected><PaymentCancel /></Protected>} />
      <Route path="/" element={<Protected><ChatApp /></Protected>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <UpgradeProvider>
            <AppRouter />
            <Toaster position="top-center" richColors />
          </UpgradeProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
